import React from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';

export function getWebsiteScrollOffset() {
  const header = document.querySelector('header');
  let offset = header?.offsetHeight || 72;
  const banner = document.getElementById('email-verification-banner');
  if (banner) {
    offset += banner.offsetHeight;
  }
  return offset;
}

export function scrollToWebsiteSection(id, behavior = 'smooth') {
  const element = document.getElementById(id);
  if (!element) return false;
  const offset = getWebsiteScrollOffset();
  const top = element.getBoundingClientRect().top + window.pageYOffset - offset;
  window.scrollTo({ top, behavior });
  return true;
}

const ScrollLink = ({ children, to, ...props }) => {
  const location = useLocation();
  const navigate = useNavigate();

  const waitForElementById = async (id, timeoutMs = 3000, intervalMs = 50) => {
    let el = document.getElementById(id);
    if (el) return el;
    const start = performance.now();
    while (performance.now() - start < timeoutMs) {
      await new Promise((resolve) => setTimeout(resolve, intervalMs));
      el = document.getElementById(id);
      if (el) return el;
    }
    return null;
  };

  const handleClick = async (e) => {
    e.preventDefault();

    if (to.includes('#')) {
      const id = to.split('#')[1];

      if (location.pathname !== '/') {
        navigate('/', { state: { scrollToId: id } });
        return;
      }

      const el = await waitForElementById(id);
      if (el) {
        scrollToWebsiteSection(id);
        window.history.replaceState(null, '', `#${id}`);
      }
    } else {
      navigate(to);
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  };

  return (
    <Link to={to} onClick={handleClick} {...props}>
      {children}
    </Link>
  );
};

export default ScrollLink;
